/*
 * 账户相关的 CGI 接口
 * author: zaleguo
 * time: 2020-04-01
 */

import { smb_fetch, getAgpApiUrl } from '../../fetch';

/**
 * 通过搜索获取文章
 * @param {object} data 请求数据
 */
export const getArticleBySearch = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'search'); // knowledge/search
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};
/**
 * 获取目录列表
 * @param {object} data 请求数据
 */
export const getCatalogList = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_catalog_list'); // knowledge/get_catalog_list
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取文章列表
 * @param {object} data 请求数据
 */
export const getPostList = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_post_list'); // knowledge/get_catalog_list
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取文章列表
 * @param {object} data 请求数据
 */
export const getPostListByTag = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_post_list_by_tag');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取品牌招商文章列表
 * @param {object} data 请求数据
 */
export const getProjectList = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_project_list'); // knowledge/get_catalog_list
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};
/**
 * 获取文章详情
 * @param {object} data 请求数据
 */
export const getPost = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_post'); // knowledge/get_catalog_list
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取品牌招商文章详情
 * @param {object} data 请求数据
 */
export const getProjectInfo = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_project'); // knowledge/get_catalog_list
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取首页推荐数据
 * @param {object} data 请求数据
 */
export const get_index_recommend = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_index_recommend');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取首页数据
 * @param {object} data 请求数据
 */
export const get_index = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_index');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取内容品类数据
 * @param {object} data 请求数据
 */
export const getContentTypeList = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_content_type_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取项目类型数据
 * @param {object} data 请求数据
 */
export const getProjectTypeList = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_project_type_list');
  const params = $.extend(
    true,
    {
      method: 'GET',
    },
    data,
  );

  return smb_fetch(url, params, isShowError);
};

/**
 * 获取项目类型数据
 * @param {object} data 请求数据
 */
export const getProjectSpreadPic = (data = {}, isShowError = true) => {
  const url = getAgpApiUrl('knowledge', 'get_project_spread_pic');
  return url;
};

export default {
  getArticleBySearch,
  getCatalogList,
  getPostList,
  getPost,
  get_index,
  get_index_recommend,
  getProjectList,
  getProjectInfo,
  getProjectTypeList,
  getContentTypeList,
  getProjectSpreadPic,
  getPostListByTag,
};
